<template>
    <Teleport to="body">
        <Transition name="simple-drawer">
            <div v-if="isOpen" class="fixed inset-0 z-50 flex items-end">
                <!-- Overlay -->
                <div
                    @click="closeDrawer"
                    class="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
                ></div>

                <!-- Drawer Content -->
                <div
                    class="bg-bg relative w-full rounded-t-xl border-2 border-zinc-700 shadow-xl"
                    @click.stop
                >
                    <slot v-if="isOpen" />
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
export default {
    name: 'SimpleDrawer',
    props: {
        hashKey: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isOpen: false,
        }
    },
    watch: {
        $route: {
            handler(newRoute, oldRoute) {
                this.checkHash(newRoute, oldRoute)
            },
            immediate: false,
        },
    },
    methods: {
        checkHash(newRoute, oldRoute) {
            if (newRoute.hash === `#${this.hashKey}`) {
                this.isOpen = true
            } else if (oldRoute?.hash === `#${this.hashKey}`) {
                this.isOpen = false
            }
        },
        closeDrawer() {
            if (this.$route.hash === `#${this.hashKey}`) {
                this.$router.replace({ hash: '' })
            }
        },
    },
    mounted() {
        this.checkHash(this.$route, null)
    },
}
</script>

<style scoped>
.simple-drawer-enter-active,
.simple-drawer-leave-active {
    transition: opacity 0.3s ease;
}

.simple-drawer-enter-active .bg-bg,
.simple-drawer-leave-active .bg-bg {
    transition: transform 0.3s ease;
}

.simple-drawer-enter-from,
.simple-drawer-leave-to {
    opacity: 0;
}

.simple-drawer-enter-from .bg-bg,
.simple-drawer-leave-to .bg-bg {
    transform: translateY(100%);
}
</style>
